module.exports = __webpack_public_path__ + "img/PFSCHelp2.fecc91e8.png";